import React from "react";
import "./Leyora.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Leyora9images from "../../Media/Kotwis/Leyora/Leyora9";
import Leyora10images from "../../Media/Kotwis/Leyora/Leyora 10/Leyora10";
import Leyora12images from "../../Media/Kotwis/Leyora/Leyora 12/Leyora12";

const imageMap = {
  Leyora9images,
  Leyora10images,
  Leyora12images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="orlens" className="produk-orleans">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
